/**
 * 首页 接口的统一出口
 */
import axios from "../http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块，把请求字段直接映射过来

const api = "/api/";

const index = {
  // 首页
  index(params) {
    return axios.get(api + "pcIndex", { params: params });
  },
  // 新闻分类
  newsCate(params) {
    return axios.get(api + "news/cate", { params: params });
  },
  // 新闻列表
  newsList(params) {
    return axios.get(api + "news/list", { params: params });
  },
  // 新闻详情
  newsDetail(params) {
    return axios.get(api + "news/detail", { params: params });
  },
  // 产品分类
  goodsCate(params) {
    return axios.get(api + "goods/cate", { params: params });
  },
  // 产品列表
  goodsList(params) {
    return axios.get(api + "goods/list", { params: params });
  },
  // 产品详情
  goodsDetail(params) {
    return axios.get(api + "goods/detail", { params: params });
  },
  // 业绩分类
  productCate(params) {
    return axios.get(api + "product/cate", { params: params });
  },
  // 业绩列表
  productList(params) {
    return axios.get(api + "product/list", { params: params });
  },
  // 下载分类
  resourceCate(params) {
    return axios.get(api + "resource/cate", { params: params });
  },
  // 下载列表
  resourceList(params) {
    return axios.get(api + "resource/list", { params: params });
  },
  // // 下载
  // download(params) {
  //   return axios.get(api + "resource/download", { params: params });
  // },
  // // 登录
  // login(params) {
  //     return axios.post(api + "login", qs.stringify(params));
  // },
};

// 导出接口
export default index;
